<template>
    <section>
        <div class="contact_section5" style="padding-bottom: 130px;">
            <div class="mobile_con_wrap">
                <p data-aos="fade-up"
                    :data-aos-delay="0"
                    data-aos-once="true"
                    data-aos-duration="600"
                    data-aos-easing="ease-in-out" style="font-size: 25px; font-weight: 700; color: black; line-height: 1.5; margin-bottom: 20px;">채용 중인 직무</p>
                <p data-aos="fade-up"
                    :data-aos-delay="100"
                    data-aos-once="true"
                    data-aos-duration="600"
                    data-aos-easing="ease-in-out" style="font-size: 15px; font-weight: 400; color: #5A5A5A; line-height: 1.5; margin-bottom: 40px;">
                    더 가치있는 내일을 만들기 위한 한 걸음을 내딛고 싶다면,
                    아래 채용 공고를 통해 지원해보새요
                </p>
                <div data-aos="fade"
                    :data-aos-delay="200"
                    data-aos-once="true"
                    data-aos-duration="600"
                    data-aos-easing="ease-in-out" style="display: flex; justify-content: space-between; margin-bottom: 36px">
                    <!-- <div @click="activeIndex = -1"  class="inActive" :class="{isActive: activeIndex == -1}">전체</div> -->
                    <div @click="activeIndex = index" class="workType" :class="{isActiveMenu: activeIndex == index}" v-for="(item, index) in workPosition" :key="index">
                        {{item.name}}
                    </div>
                </div>
                <div data-aos="fade"
                    :data-aos-delay="200"
                    data-aos-once="true"
                    data-aos-duration="600"
                    data-aos-easing="ease-in-out" style="display: flex; flex-direction: column; margin-bottom: 37px">
                    <div class="joinList" v-for="(item, index) in filter" :key="index" style="display: flex; justify-content: space-between; align-items: center; border-bottom: 1px solid #E7E7E7; padding: 29px 0;">
                        <div style="width: 90%; display: flex; align-items: center;">
                            <p style="width: 20%; font-size: 16px; color: #737373; font-weight: 400;">{{workPosition[item.type - 1].name}}</p>
                            <p style="max-width: 75%; text-overflow: ellipsis; overflow: hidden; white-space: nowrap; font-size: 23px; color: black; font-weight: 700; line-height: 1.5;">{{item.title}}</p>
                        </div>
                        <img src="@/assets/images/main_v2/icon/arrow_tail_right.svg" alt="">
                    </div>
                    <!-- <div class="list" v-for="(item, index) in filter" :key="index" style="display: flex; justify-content: space-between; align-items: center; border-bottom: 1px solid #E7E7E7; padding: 13px 14px;">
                        <div style="width: 90%; display: flex; align-items: center;">
                            <p style="width: 12%; font-size: 18px; color: #737373; font-weight: 400;">{{workPosition[item.type - 1].name}}</p>
                            <p style="font-size: 18px; color: black; font-weight: 700; line-height: 1.5;">{{item.title}}</p>
                        </div>
                        <img src="@/assets/images/main_v2/icon/arrow_tail_right.svg" alt="">
                    </div> -->
                </div>
            </div>
        </div>
    </section>
</template>
<script>
import { ChevronDownIcon } from 'vue-feather-icons'
import SnackBar from '@/components/SnackBar.vue'
export default {
    components: {
        ChevronDownIcon,
        SnackBar,
    },
    data() {
        return {
            filter: [],
            activeIndex: 0,
            workPosition: [
                {
                    'name': '개발',
                    'key': 1
                },{
                    'name': '콘텐츠',
                    'key': 2
                },{
                    'name': '마케팅',
                    'key': 3
                },{
                    'name': '디자인',
                    'key': 4
                },
            ],
            noticeAll: [
                {
                    'title': '프론트엔드 개발(신규)',
                    'type': 1
                },{
                    'title': '백엔드 개발(신규)',
                    'type': 1
                },{
                    'title': '프론트엔드 개발(경력)',
                    'type': 1
                },{
                    'title': 'UI/UX 디자이너',
                    'type': 4
                },{
                    'title': '마케터(신규)',
                    'type': 3
                },{
                    'title': '마케터(경력)',
                    'type': 3
                },{
                    'title': '콘텐츠 제작팀(신규)',
                    'type': 2
                },
            ],
        }
    },
    watch: {
        activeIndex() {
            if(this.activeIndex == -1) {
                this.filter = this.noticeAll
            } else {
                this.filter = this.noticeAll.filter((item) => {
                    return item.type == this.workPosition[this.activeIndex].key
                })
            }
        }
    },
    methods: {
        openLink(val) {
            window.open(val, '_blank')
        },
        changeRow(val) {
            return val.split('\n').join('<br />')
        },
        setIcon(val)  {
            return require('@/assets/images/main_v2/icon/'+ val.icon +'.svg')
        }
        // copy(val) {
        //     navigator.clipboard.writeText(val).then(()=> {
        //         this.$store.commit('SET_SNACK_BAR_INFO' , {
        //             text: '메일주소가 복사되었습니다.',
        //             icon: 'icon-check.svg',
        //             color: 'white',
        //             background: '#1C9CD3'
        //         })
        //         this.showSnackBar = true
        //     })
        // },
    },
    created() {
        if(this.activeIndex == -1) {
            this.filter = this.noticeAll
        } else {
            this.filter = this.noticeAll.filter((item) => {
                return item.type == this.workPosition[this.activeIndex].key
            })
        }
    }
}
</script>
<style>
    .contact_section5 {
        width: 100vw;
        height:calc(var(--vh, 1vh) * 100);
        background: white;
        object-fit: inherit;
    }
    .contact_section5 .swiper-wrapper {
        transition-timing-function: linear
    }
    .contact_section5 .workType {
        padding: 4px 14px;
        color: #2C2C2C;
        font-weight: 700;
        font-size: 15px;
        border-radius: 100px;
        cursor: pointer;
        transition: all 0.2s ease;
    }
    .contact_section5 .workType:active {
        background: transparent;
    }
    .contact_section5 .isActiveMenu {
        background: #1C9CD3;
        color: white
    }
</style>